import { z } from 'zod';

export const validateNameLength = (
  value?: string,
  options?: { min?: number; max?: number; required?: boolean }
): string | undefined | boolean => {
  const { min = 1, max, required = true } = options || {};

  if (required && value === undefined) return false;

  let schema = z.string({
    required_error: 'Value is required',
    invalid_type_error: 'Value must be a string',
  });

  if (min !== undefined) {
    schema = schema.min(min, `Must be at least ${min} characters`);
  }

  if (max !== undefined) {
    schema = schema.max(max, `Must be at most ${max} characters`);
  }

  const result = schema.safeParse(value);

  if (!result.success) {
    return result.error.issues[0].message;
  }

  return undefined;
};
